import { OPTIONAL_ENVIRONMENT_VARIABLES_KEYS } from '@shared/constants/constants';

/**
 * Obtains the specified key's value from environment variables
 *
 * @param {string} key  Environment variable's key to retrieve the values from
 *
 * @returns {string}  React Web Application's environment variable value
 * @throws {Error}  Throws an error if the environment variable's
 *   value at the specified key does not exist
 */
const getEnvValue = (key: string): string => {
  const result: string = import.meta.env[key];

  if (result) return result;

  if (OPTIONAL_ENVIRONMENT_VARIABLES_KEYS.includes(key)) return '';

  throw new Error('Unable to obtain value from the environment variables.');
};

/**
 * Checks if a particular env variable is true or not.
 *
 * @param key  Key of the string holding this env variable
 */
const isTrue = (key: string) => getEnvValue(key) === 'true';

export { getEnvValue, isTrue };
